import { createAgentProfileBindingApi } from "@wakeloop/api-client";
import type { EnsureAgentProfilePrimaryBindingResponse } from "@wakeloop/schemas/types";
import { resolveBaseUrl } from "../config/base-url";
import type { WakeLoopProfile } from "../config/wakeloop-profiles-api";
import { buildWakeLoopRequestContextFromProfile } from "../config/wakeloop-request-context";
import { createCliApiClientFoundation } from "../space/api-client-foundation";

export async function updateAgentProfilePrimaryBindingModelSelection(input: {
  modelId: string;
  profile: WakeLoopProfile;
  reasoningLevel?: string | null;
}): Promise<EnsureAgentProfilePrimaryBindingResponse> {
  const gatewayUrl = await resolveBaseUrl();
  const api = createAgentProfileBindingApi(
    createCliApiClientFoundation(gatewayUrl)
  );
  const modelId = normalizeRequiredText(input.modelId, "--model is required.");
  const reasoningLevel = normalizeOptionalText(input.reasoningLevel);

  return await api.updatePrimaryBindingModelSelection({
    agentProfileId: input.profile.wakeLoopProfileId,
    modelId,
    requestContext: buildWakeLoopRequestContextFromProfile({
      wakeLoopProfile: input.profile,
    }),
    ...(reasoningLevel ? { reasoningLevel } : {}),
  });
}

function normalizeRequiredText(value: string, message: string): string {
  const normalized = normalizeOptionalText(value);
  if (!normalized) {
    throw new Error(message);
  }
  return normalized;
}

function normalizeOptionalText(
  value: string | null | undefined
): string | null {
  const normalized = String(value ?? "").trim();
  return normalized.length > 0 ? normalized : null;
}
